import { MainAttachments, type MainAttachmentsSkin } from '@/deskUiSkeletons/Page/MainAttachments'

const skin: MainAttachmentsSkin = {
  empty: 'mx-auto max-w-5xl rounded border border-slate-200 bg-white p-5 text-sm text-slate-500',
  root: 'mx-auto max-w-5xl rounded border border-slate-200 bg-white p-5',
  header: 'mb-4 flex items-center justify-between',
  title: 'text-xl font-semibold text-slate-900',
  count: 'text-xs text-slate-500',
  body: 'grid gap-5 md:grid-cols-[minmax(0,1fr)_240px]',
  preview: 'flex min-h-72 items-center justify-center bg-slate-50',
  image: 'max-h-[70vh] max-w-full object-contain',
  side: 'flex min-w-0 flex-col gap-4',
  meta: 'min-w-0',
  metaTitle: 'break-words font-semibold text-slate-900',
  metaDescription: 'mt-2 text-sm text-slate-600',
  nav: 'flex gap-2',
  button: 'rounded border border-slate-300 bg-white px-3 py-1.5 text-sm hover:bg-slate-50',
  thumbs: 'grid grid-cols-3 gap-2',
  thumb: 'overflow-hidden rounded border p-1',
  thumbSelected: 'border-blue-600',
  thumbUnselected: 'border-slate-200',
  thumbImage: 'aspect-square h-full w-full object-cover',
}

export function WikiMainAttachments() {
  return <MainAttachments skin={skin} />
}
